<template>
  <v-btn color="secondary" @click="runAction">
    <v-icon v-if="!loading">{{icon}}</v-icon>
    <v-progress-circular v-else :size="20" :width="2" color="primary" indeterminate />
    <span v-if="title">&nbsp;{{title}}</span>
  </v-btn>
</template>
<style scoped>
button:disabled {
  color: hsla(0, 0%, 100%, 0.3) !important;
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    action: {
      type: Function,
      required: true
    },
    filename: {
      type: String,
      required: true
    }
  },
  watch: {
    action: {
      deep: true,
      immediate: true,
      handler() {
        console.log("DownloadButton action Changed");
        this.resetDownload();
      }
    }
  },
  data: () => ({
    downloadBlob: null,
    blobUrl: null,
    loading: false
  }),
  computed: {
    icon() {
      return this.blobUrl ? "cloud_done" : "cloud_download";
    }
  },
  methods: {
    download() {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.href = this.blobUrl;
      a.download = this.filename;
      a.click();
      document.body.removeChild(a);
    },
    resetDownload() {
      if (this.blobUrl) {
        window.URL.revokeObjectURL(this.blobUrl);
      }
      this.blobUrl = null;
      this.downloadBlob = null;
    },
    onResult(Blob) {
      const url = window.URL.createObjectURL(Blob);
      this.downloadBlob = Blob;
      this.blobUrl = url;
      this.loading = false;
      console.log("onResult", this.blobUrl);
      this.download();
    },
    onError(Err) {
      console.log("onError", Err);
      this.loading = false;
      this.$emit("download-error", "Download failed");
    },
    runAction() {
      if (!this.loading) {
        if (this.blobUrl) {
          this.download();
        } else {
          this.loading = true;
          this.action()
            .then(this.onResult)
            .catch(this.onError);
        }
      }
    }
  }
};
</script>
